import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const InAppSendSkip = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M19.3201 9.18994V4.68994C19.3201 4.39157 19.2015 4.10542 18.9906 3.89445C18.7796 3.68347 18.4934 3.56494 18.1951 3.56494H4.69507C4.3967 3.56494 4.11055 3.68347 3.89957 3.89445C3.68859 4.10542 3.57007 4.39157 3.57007 4.68994V17.0649C3.57007 17.3633 3.68859 17.6495 3.89957 17.8604C4.11055 18.0714 4.3967 18.1899 4.69507 18.1899H9.19507"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.57007 6.93994H19.3201"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.4451 15.9399C11.4451 16.5309 11.5615 17.1161 11.7876 17.662C12.0138 18.208 12.3452 18.7041 12.7631 19.1219C13.181 19.5398 13.677 19.8713 14.223 20.0974C14.769 20.3235 15.3541 20.4399 15.9451 20.4399C16.536 20.4399 17.1212 20.3235 17.6671 20.0974C18.2131 19.8713 18.7092 19.5398 19.127 19.1219C19.5449 18.7041 19.8764 18.208 20.1025 17.662C20.3287 17.1161 20.4451 16.5309 20.4451 15.9399C20.4451 15.349 20.3287 14.7638 20.1025 14.2179C19.8764 13.6719 19.5449 13.1758 19.127 12.758C18.7092 12.3401 18.2131 12.0086 17.6671 11.7825C17.1212 11.5563 16.536 11.4399 15.9451 11.4399C15.3541 11.4399 14.769 11.5563 14.223 11.7825C13.677 12.0086 13.181 12.3401 12.7631 12.758C12.3452 13.1758 12.0138 13.6719 11.7876 14.2179C11.5615 14.7638 11.4451 15.349 11.4451 15.9399V15.9399Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.6326 14.2524L14.2576 17.6274"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.2576 14.2524L17.6326 17.6274"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
